import {
    getForcedControlGroup,
    getForcedTest1Group,
    getForcedTest2Group,
    getForcedTest3Group,
    getForcedTestGroup,
} from "@/utils/settings";

export enum ExperimentIds {
    // do not remove this is permanent exp for splitting users into segments
    SEGMENTS = "segments",
    SENIORS_FUNNEL = "webtest_seniors_funnel_FAEX_573_jan25",
    TIKTOK_FUNNEL = "webtest_tt_funnel_iter2_FAEX_642_feb25",
    WHATSAPP_CONNECTION = "webtest_whatsapp_connection_DEV_3978_feb25",
    PRICE_INCREASE = "webtest_price_increase_FAEX_634_feb25",
    BEGINNERS_FLOW = "webtest_beginners_flow_FAEX_599_feb25",
    BUNDLE_UPSELLS = "webtest_bundle_upsells_FAEX_641_feb25",
    PAYWALL_CHANGES = "webtest_paywall_changes_FAEX_618_feb25",
    CORE_USERS_FLOW = "webtest_core_users_flow_FAEX_539_feb25",
    PAYWALL_SOCIAL_PROOF = "webtest_paywall_social_proof_FAEX_643_feb25",
}

export const enum ExperimentVariants {
    CONTROL = "control",
    TEST = "test",
    TEST_1 = "test_1",
    TEST_2 = "test_2",
    TEST_3 = "test_3",
    NOT_ALLOCATED = "not_allocated",
    SEGMENT_A = "segment_A",
    SEGMENT_B = "segment_B",
}

export const TEST_VARIANTS = [
    ExperimentVariants.TEST,
    ExperimentVariants.TEST_1,
    ExperimentVariants.TEST_2,
    ExperimentVariants.TEST_3,
];

export const groupByForcedParams: Record<ExperimentVariants, string[]> = {
    [ExperimentVariants.CONTROL]: getForcedControlGroup(),
    [ExperimentVariants.TEST]: getForcedTestGroup(),
    [ExperimentVariants.TEST_1]: getForcedTest1Group(),
    [ExperimentVariants.TEST_2]: getForcedTest2Group(),
    [ExperimentVariants.TEST_3]: getForcedTest3Group(),
    [ExperimentVariants.NOT_ALLOCATED]: [],
    [ExperimentVariants.SEGMENT_A]: [],
    [ExperimentVariants.SEGMENT_B]: [],
};

// need to track paywall id for analytics
export const paywallExperimentsIds = [
    ExperimentIds.PRICE_INCREASE,
    ExperimentIds.PAYWALL_CHANGES,
    ExperimentIds.TIKTOK_FUNNEL,
    ExperimentIds.PAYWALL_SOCIAL_PROOF,
];
